import { Component } from "react";

import { PendingUnprocessedSpecialtyGroupExceptionsChanges } from "@app/projects/servicing-provider/PendingUnprocessedSpecialtyGroupExceptionsChanges";
import { FlyoutLink } from "@app/shared/Flyouts";

interface PendingUnprocessedSpecialtyGroupExceptionsChangesSidePanelLinkProps {

  projectId: number;

}

export default class PendingUnprocessedSpecialtyGroupExceptionsChangesSidePanelLink extends Component<PendingUnprocessedSpecialtyGroupExceptionsChangesSidePanelLinkProps> {
  constructor(props: PendingUnprocessedSpecialtyGroupExceptionsChangesSidePanelLinkProps) {
    super(props);

    this.state = {
      registerTriggerClose: null,
    };
  }


  public render() {
    return (
      <FlyoutLink
        classNames="text-info ml-3"
        content={{
          body: (
            <PendingUnprocessedSpecialtyGroupExceptionsChanges
              projectId={this.props.projectId}
            />
          ),
          title: "Unprocessed Specialty Group Exceptions",
        }}
        testId="pending-unprocessed-specialty-group-exceptions-changes__flyout"
      >
        <i className="fa fa-rocket" /> View and Process
      </FlyoutLink>
    );
  }
}

